import Keycloak from 'keycloak-js'

fetch('./config/config.json', {cache: 'reload'})
  .then(res => res.json())
  .then(config => {
        window.keycloak = new Keycloak({
          url: config.ssoUrl,
          realm: config.ssoRealm,
          clientId: config.ssoClient
        })
        window.keycloak.init({
          onLoad: 'login-required',
          promiseType: 'native',
          checkLoginIframe: false,
          pkceMethod: 'S256'
        }).then(authenticated => {
          const hash = window.location.hash.split("?")[0].split("/")[0].substring(1)
          if(hash === 'Sftp') {
            document.querySelector('body').innerHTML = `
                <main>
                  <div id="mainheader">
                    <gasmonitoring-frontend-header></gasmonitoring-frontend-header>
                  </div>
                  <div id="maincontent">
                    <isceco-message lifetime="5"></isceco-message>
                    <gasmonitoring-frontend-admin-sftp-view></gasmonitoring-frontend-admin-sftp-view>
                  </div>
                  <div id="mainfooter">
                    <gasmonitoring-frontend-footer></gasmonitoring-frontend-footer>
                  </div>
                </main>            `
          } else {
            document.querySelector('body').innerHTML = `
                <main>
                  <div id="mainheader">
                    <gasmonitoring-frontend-header></gasmonitoring-frontend-header>
                    <gasmonitoring-frontend-status></gasmonitoring-frontend-status>
                    <gasmonitoring-frontend-horizontal-navigation></gasmonitoring-frontend-horizontal-navigation>
                  </div>
                  <div id="maincontent">
                    <isceco-message lifetime="5" style="margin-top: -20px; margin-bottom: 20px"></isceco-message>
                    <gasmonitoring-frontend-main-view></gasmonitoring-frontend-main-view>
                    <isceco-scroll-top></isceco-scroll-top>
                  </div>
                  <div id="mainfooter">
                    <gasmonitoring-frontend-footer></gasmonitoring-frontend-footer>
                  </div>
                </main>            `
          }
        })

        // used for Global Logout context
        window.keycloak.onTokenExpired = () => {
          keycloak.updateToken(-1)
            .catch(function () {
              console.error('Failed to refresh the token, or the session has expired') // NOSONAR
            })
        }
  })
